import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // list encounters state
  vimOSEncounter: '',
  isEncounterListLoading: false,
  encounterList: [],
  encounterListCount: 0,
  // get encounter state
  isEncounterDetailsLoading: false,
  encounterDetails: '',
  // create encounter state
  isEncounterCreateLoading: false,
  newEncounter: '',
  // complete encounter state
  isEncounterCompleteLoading: false,
  // remove encounter state
  isEncounterRemoveLoading: false,

  selectedEncounter: '',
  isEncounterUpdateLoading: false,

  istranscriptionLoading: false,
  transcriptionbyIdValue: [],
  mobileViewStatus: {},
  isMobileRecord: false,
  newEncounterfromMic: false,
  auraDemoConversation: [],

  prerecordedTranscriptId: '',
  prerecordedTranscript: '',
  prerecordedTranscriptSpeakers: {},
  deletedEncounters: [],
  deletedEncountersLoading: false,
  scribePractitioners: [],
  encounterRefreshInterval: 60_000,
  isOPUpgradeModalVisible: false,
  pinnedEncounterIds: [],
  // pinned encounters state
  isPinnedEncounterListLoading: false,
  pinnedEncounterList: [],
  pinnedEncounterListCount: 0,
  encountersCSVColumnMappings: {},
  encountersCSVDateTimeFormats: {},
  encountersCSVColumnMappingsLoading: false,
  encountersCSVDateTimeFormatsLoading: false,
};

const encountersSlice = createSlice({
  name: 'encountersSlice',
  initialState,
  reducers: {
    encounterListLoading: (state, { payload }) => {
      state.isEncounterListLoading = payload;
    },
    encounterListSlice: (state, { payload }) => {
      state.encounterList = payload;
    },
    encounterListCountSlice: (state, { payload }) => {
      state.encounterListCount = payload;
    },
    encounterDetailsLoading: (state, { payload }) => {
      state.isEncounterDetailsLoading = payload;
    },
    encounterUpdateLoading: (state, { payload }) => {
      state.isEncounterUpdateLoading = payload;
    },
    encounterDetailsSlice: (state, { payload }) => {
      state.encounterDetails = payload;
    },
    vimOSEncounterSlice: (state, { payload }) => {
      state.vimOSEncounter = payload;
    },
    encounterCreateLoading: (state, { payload }) => {
      state.isEncounterCreateLoading = payload;
    },
    selectedEncounterSlice: (state, { payload }) => {
      state.selectedEncounter = payload;
    },
    newEncounterSlice: (state, { payload }) => {
      state.newEncounter = payload;
    },
    encounterCompleteLoading: (state, { payload }) => {
      state.isEncounterCompleteLoading = payload;
    },
    encounterRemoveLoading: (state, { payload }) => {
      state.isEncounterRemoveLoading = payload;
    },
    transcriptionLoading: (state, { payload }) => {
      state.istranscriptionLoading = payload;
    },
    resetEncounterState: () => {
      return initialState;
    },
    partialResetEncounterState: (state, { payload }) => {
      state.encounterDetails = {};
      state.transcriptionbyIdValue = [];
    },
    transcriptionbyIdSlice: (state, { payload }) => {
      state.transcriptionbyIdValue = payload;
    },
    mobileViewStatusSlice: (state, { payload }) => {
      state.mobileViewStatus = payload;
    },
    setMobileRecord: (state, { payload }) => {
      state.isMobileRecord = payload;
    },
    newEncounterfromMicSlice: (state, { payload }) => {
      state.newEncounterfromMic = payload;
    },
    getAuraDemoConversationSlice: (state, { payload }) => {
      state.auraDemoConversation = payload;
    },
    prerecordedTranscriptIdSlice: (state, { payload }) => {
      state.prerecordedTranscriptId = payload;
    },
    prerecordedTranscriptSlice: (state, { payload }) => {
      state.prerecordedTranscript = payload;
    },
    prerecordedTranscriptSpeakersSlice: (state, { payload }) => {
      state.prerecordedTranscriptSpeakers = payload;
    },
    deletedEncountersSlice: (state, { payload }) => {
      state.deletedEncounters = payload;
    },
    deletedEncountersLoadingSlice: (state, { payload }) => {
      state.deletedEncountersLoading = payload;
    },
    scribePractitionersSlice: (state, { payload }) => {
      state.scribePractitioners = payload;
    },
    encounterRefreshIntervalSlice: (state, { payload }) => {
      state.encounterRefreshInterval = payload;
    },
    isOPUpgradeModalVisibleSlice: (state, { payload }) => {
      state.isOPUpgradeModalVisible = payload;
    },
    totalEncounterWillBeArchivedSlice: (state, { payload }) => {
      state.totalEncounterWillBeArchived = payload;
    },
    addPinnedEncounter: (state, { payload }) => {
      if (!state.pinnedEncounterIds.includes(payload)) {
        state.pinnedEncounterIds.push(payload);
      }
    },
    removePinnedEncounter: (state, { payload }) => {
      state.pinnedEncounterIds = state.pinnedEncounterIds.filter(
        (id) => id !== payload
      );
    },
    clearPinnedEncounters: (state) => {
      state.pinnedEncounterIds = [];
      state.pinnedEncounterList = [];
      state.pinnedEncounterListCount = 0;
    },
    pinnedEncounterListLoading: (state, { payload }) => {
      state.isPinnedEncounterListLoading = payload;
    },
    pinnedEncounterListSlice: (state, { payload }) => {
      state.pinnedEncounterList = payload;
    },
    pinnedEncounterListCountSlice: (state, { payload }) => {
      state.pinnedEncounterListCount = payload;
    },
    encountersCSVColumnMappingsSlice: (state, { payload }) => {
      state.encountersCSVColumnMappings = payload;
    },
    encountersCSVDateTimeFormatsSlice: (state, { payload }) => {
      state.encountersCSVDateTimeFormats = payload;
    },
    encountersCSVColumnMappingsLoadingSlice: (state, { payload }) => {
      state.encountersCSVColumnMappingsLoading = payload;
    },
    encountersCSVDateTimeFormatsLoadingSlice: (state, { payload }) => {
      state.encountersCSVDateTimeFormatsLoading = payload;
    },
  },
});

const { actions, reducer } = encountersSlice;

export const {
  encounterListLoading,
  encounterListSlice,
  encounterListCountSlice,
  encounterRefreshIntervalSlice,
  encounterCreateLoading,
  encounterCompleteLoading,
  selectedEncounterSlice,
  newEncounterSlice,
  encounterDetailsLoading,
  encounterUpdateLoading,
  partialResetEncounterState,
  encounterDetailsSlice,
  encounterRemoveLoading,
  transcriptionLoading,
  resetEncounterState,
  transcriptionbyIdSlice,
  mobileViewStatusSlice,
  setMobileRecord,
  newEncounterfromMicSlice,
  getAuraDemoConversationSlice,
  prerecordedTranscriptIdSlice,
  prerecordedTranscriptSlice,
  prerecordedTranscriptSpeakersSlice,
  deletedEncountersSlice,
  deletedEncountersLoadingSlice,
  scribePractitionersSlice,
  isOPUpgradeModalVisibleSlice,
  totalEncounterWillBeArchivedSlice,
  addPinnedEncounter,
  removePinnedEncounter,
  clearPinnedEncounters,
  pinnedEncounterListLoading,
  pinnedEncounterListSlice,
  pinnedEncounterListCountSlice,
  vimOSEncounterSlice,
  encountersCSVColumnMappingsSlice,
  encountersCSVDateTimeFormatsSlice,
  encountersCSVColumnMappingsLoadingSlice,
  encountersCSVDateTimeFormatsLoadingSlice,
} = actions;

export default reducer;
